module.exports = __webpack_public_path__ + "static/media/loudspeaker.e95ef436.png";